<template>
  <div class="class">
    <teacherHeader
      :logo_name="logo_name"
      @info-event="myInfoEvent"
      @public-event="publicEvent"
    ></teacherHeader>
    <div class="task_cont bg_blue">
      <div class="task_cont_div bg_white radius8 bs">
        <div class="task_cont_nav f18px cl_dark">
          <router-link
            :to="item.url"
            class="task_cont_nav_list"
            v-for="(item, index) in nav"
            :key="index"
            :class="{ on: item.id == nav_cur }"
            >{{ item.name }}</router-link
          >
        </div>
        <div class="task_subject cl_gray tc">
          <span
            class="task_subject_list bg_gray cur"
            v-for="(item, index) in subject"
            :key="index"
            @click="subjectCheck(item.subjectId)"
            :class="{ on: subject_cur == item.subjectId }"
            >{{ item.subjectName }}</span
          >
        </div>
        <div class="task_video">
          <div class="task_video_l">
            <div class="famous_screen_list">
              <el-select
                v-model="material_cur"
                placeholder="全部"
                @change="materialSelect"
              >
                <el-option
                  v-for="item in material"
                  :key="item.Id"
                  :label="item.Name"
                  :value="item.Id"
                ></el-option>
              </el-select>
            </div>
            <div
              class="task_video_nav radius8 mat20 cl_dark"
              v-if="chapter.length > 0"
            >
              <div
                class="task_nav_first mab20"
                v-for="(item, index) in chapter"
                :key="index"
              >
                <div
                  class="task_nav_first_title f16px cur"
                  @click="firstOpen(index)"
                  :class="{ on: item.open }"
                >
                  <img src="../../../static/select_right.png" class="mar5" />
                  <span style="font-size: 14px">{{ item.gradeName }}</span>
                </div>
                <div
                  class="task_nav_second mat10"
                  v-for="(second, secondIndex) in item.subordinate"
                  :key="secondIndex"
                  v-if="item.open"
                >
                  <div
                    class="task_nav_second_title cur"
                    @click="secondOpen(index, secondIndex)"
                    :class="{ on: second.open }"
                    :title="second.name"
                  >
                    <img src="../../../static/select_right.png" class="mar5" />
                    <span style="font-size: 13px" class="clip">{{
                      second.name
                    }}</span>
                  </div>

                  <div
                    class="task_nav_three"
                    v-if="second.open"
                    v-for="(three, threeIndex) in second.subordinate"
                    :key="threeIndex"
                  >
                    <div
                      class="
                        task_nav_three_title task_nav_second_title
                        clip
                        mat10
                        cur
                      "
                      @click="threeOpen(index, secondIndex, threeIndex)"
                      :class="{ on: three.open }"
                      :title="three.name"
                    >
                      <img
                        src="../../../static/select_right.png"
                        class="mar5"
                      />
                      <span style="font-size: 13px" class="clip">{{
                        three.chapter
                      }}</span>
                    </div>
                    <div
                      v-if="three.open"
                      style="font-size: 13px"
                      v-for="(four, fourIndex) in three.subordinate"
                      :key="fourIndex"
                    >
                      <div
                        @click="
                          knowledgeCheck(
                            four.unit,
                            second.id,
                            three.chapter,
                            item.gradeId
                          )
                        "
                        class="task_nav_three_title clip mat10 cur"
                        :title="four.unit"
                        :class="{ on: four.unit == chapter_cur }"
                      >
                        <span style="font-size: 13px;margin-left:10px" class="clip">{{
                          four.unit
                        }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="task_video_r"
            v-if="chapter_cur ||firstOpenId||chapter_str||pack_type_id"
          >
            <div class="task_video_screen">
              <div class="test_screen cl_gray">
                <div class="test_screen_l f16px">
                  <span class="inline">课程定位</span><i class="inline">：</i>
                </div>
                <div class="test_screen_r tc">
                  <span
                    class="test_screen_list bg_gray"
                    v-for="(item, index) in direction"
                    :key="index"
                    :class="{ on: item.id == direction_cur }"
                    @click="directionCheck(item.id)"
                    >{{ item.name }}</span
                  >
                </div>
              </div>
              <div class="test_screen cl_gray" v-if="teacher.length > 0">
                <div class="test_screen_l f16px">
                  <span class="inline">主讲老师</span><i class="inline">：</i>
                </div>
                <div class="test_screen_r tc">
                  <span
                    class="test_screen_list bg_gray"
                    v-for="(item, index) in teacher"
                    :key="index"
                    :class="{ on: item.teacher_id == teacher_cur }"
                    @click="teacherCheck(item.teacher_id)"
                    >{{ item.name }}</span
                  >
                </div>
              </div>
              <div class="test_screen cl_gray">
                <div class="test_screen_l f16px">
                  <span class="inline">排序</span><i class="inline">：</i>
                </div>
                <div class="test_screen_r tc">
                  <span
                    class="test_screen_list bg_gray"
                    v-for="(item, index) in order"
                    :key="index"
                    :class="{ on: item.type == order_cur }"
                    @click="orderCheck(item.type)"
                    >{{ item.name }}</span
                  >
                </div>
              </div>
            </div>
            <div class="f18px cl_gray mat30">
              共 <span class="cl_yel">{{ total }}</span> 个课程
            </div>
            <div class="task_video_cont mat20" v-if="list.length > 0">
              <div
                class="task_video_list radius8 bs"
                v-for="(item, index) in list"
                :key="index"
              >
                <div class="task_video_list_top flex">
                  <div class="task_video_list_l flex">
                    <router-link
                      :to="{ path: '/video', query: { id: item.id } }"
                      class="task_video_list_img"
                      ><img :src="item.pic" class="block"
                    /></router-link>
                    <div class="task_video_list_text">
                      <div class="task_video_list_text_title">
                        <span
                          class="cl_white tc mar10"
                          :class="[
                            { increase: item.direction == '提高' },
                            { notch: item.direction == '拔尖' },
                          ]"
                          >{{ item.direction }}</span
                        >
                        <router-link
                          :to="{ path: '/video', query: { id: item.id } }"
                          class="f20px"
                          >{{ item.name }}</router-link
                        >
                      </div>
                      <p class="cl_dark mat10">
                        <span class="cl_gray">主讲老师：</span
                        >{{ item.teacher_name }}
                      </p>
                      <p class="cl_dark mat10">
                        <span class="cl_gray">播放：</span>{{ item.browse_num }}
                      </p>
                    </div>
                  </div>
                  <div class="task_video_list_r tc">
                    <div
                      class="
                        task_video_list_r_add
                        radius20
                        cur
                        f18px
                        cl_white
                        tc
                        on
                      "
                      v-if="item.is_exist == 1"
                      @click="removeAll(index)"
                    >
                      -整包移出作业篮
                    </div>
                    <div
                      class="
                        task_video_list_r_add
                        radius20
                        cur
                        f18px
                        cl_white
                        tc
                      "
                      v-else
                      @click="joinAll(index)"
                    >
                      +整包加入作业篮
                    </div>
                    <p class="cl_gray mat40">
                      已添加<span class="cl_yel">{{ item.check_num }}</span
                      >讲
                    </p>
                  </div>
                </div>
                <div
                  class="task_video_list_btm mat30"
                  :class="{ open: item.open }"
                >
                  <div
                    class="task_video_list_item flex"
                    v-for="(second, secondIndex) in item.video"
                    :key="secondIndex"
                  >
                    <span class="clip cl_dark">{{ second.name }}</span>
                    <div
                      class="task_video_list_item_btn cur tc cl_white on"
                      v-if="second.is_exist == 1"
                      @click="remove(index, secondIndex)"
                    >
                      -移出作业篮
                    </div>
                    <div
                      class="task_video_list_item_btn cur tc cl_white"
                      v-else
                      @click="join(index, secondIndex)"
                    >
                      +加入作业篮
                    </div>
                  </div>
                </div>
                <div
                  class="tc task_video_list_slide cl_violet cur"
                  v-if="item.video.length > 2"
                  :class="{ open: item.open }"
                  @click="listOpen(index)"
                >
                  <p>
                    {{ item.open ? "收起" : "查看" }}全部{{
                      item.video.length
                    }}讲课程
                  </p>
                  <img
                    src="../../../static/select_violet.png"
                    class="bg_white"
                  />
                </div>
              </div>
            </div>
            <div class="famous_page flex" v-if="list.length > 0">
              <div class="famous_page_l f16px cl_gray"></div>
              <div class="famous_page_r cl_dark">
                <el-pagination
                  background
                  layout="prev, pager, next, jumper"
                  @current-change="handleCurrentChange"
                  :page-size="pageSize"
                  :current-page="currentPage"
                  :total="total"
                ></el-pagination>
              </div>
            </div>
            <div class="choice_empty tc f18px cl_gray" v-if="list.length == 0">
              <p>找不到内容，请重新选择。</p>
            </div>
          </div>
          <div class="task_video_r" v-else>
            <div class="choice_empty tc f18px cl_gray" v-if="list.length == 0">
              <p>请先选择章节列表。</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 作业篮 -->
    <router-link to="/basket" class="basket">
      <el-popover placement="bottom-start" trigger="hover">
        <div class="basket_hide" v-if="basket.subject_data.length > 0">
          <table class="basket_hide_cont f16px">
            <tr class="basket_hide_item cl_dark">
              <td align="center">学科</td>
              <td align="center">视频</td>
              <td align="center">试卷</td>
            </tr>
            <tr
              class="basket_hide_item cl_gray"
              v-for="(item, index) in basket.subject_data"
              :key="index"
            >
              <td align="center">{{ item.subjectName }}</td>
              <td align="center">
                {{
                  item.video_num == null ||
                  item.video_num == "" ||
                  item.video_num == 0
                    ? "-"
                    : item.video_num
                }}
              </td>
              <td align="center">
                {{
                  item.shijuan_num == null ||
                  item.shijuan_num == "" ||
                  item.shijuan_num == 0
                    ? "-"
                    : item.shijuan_num
                }}
              </td>
            </tr>
          </table>
          <div class="tc mat10">
            <router-link to="/basket" class="cl_blue"
              >预览预选作业 ></router-link
            >
          </div>
        </div>
        <el-button slot="reference" class="basket_link">
          <img src="../../../static/basket_icon.png" />
          <div class="basket_link_text cl_white">
            <p class="f20px">作业篮</p>
            <p class="f16px mat5">
              <span class="cl_yel">{{ basket.count }}</span
              >项内容
            </p>
          </div>
        </el-button>
      </el-popover>
    </router-link>
  </div>
</template>

<script>
import teacherHeader from "../../components/teacher_header.vue";

export default {
  name: "task_video",
  components: {
    teacherHeader,
  },
  props: {},
  data() {
    return {
      myInfo: {},
      public: {},
      logo_name: "学科作业资源库",
      nav: [
        {
          id: 1,
          name: "视频作业",
          url: "/task_video",
        },
        {
          id: 2,
          name: "试卷作业",
          url: "/task_paper",
        },
        {
          id: 3,
          name: "习题作业",
          url: "/task_topic",
        },
      ],
      nav_cur: 1,
      subject: [], //学科
      subject_cur: {},
      material: [], //教材
      material_cur: "",
      chapter: [], //章节
      chapter_cur: "",
      teacher: [], //教师
      teacher_cur: "",
      direction: [
        {
          name: "全部",
          id: "",
        },
        {
          name: "基础",
          id: "基础",
        },
        {
          name: "提高",
          id: "提高",
        },
        {
          name: "拔尖",
          id: "拔尖",
        },
      ], //定位
      direction_cur: "",
      order: [
        {
          type: "rank",
          name: "默认",
        },
        {
          type: "is_pick",
          name: "推荐",
        },
        {
          type: "is_hot",
          name: "热门",
        },
        {
          type: "browse_num",
          name: "浏览数量",
        },
        {
          type: "add_time",
          name: "最新",
        },
      ], //排序
      order_cur: "rank",
      basket: {
        count: 0,
        subject_data: [],
      }, //作业篮
      list: [], //试卷列表
      currentPage: 1, //当前页数
      pageSize: 10, //每页数量
      total: 0, //总页数
      type: -1,
      firstOpenId: "",
      chapter_str: "",
      pack_type_id: "",
    };
  },
  created() {},
  mounted() {
    this.getSubject();
    this.getBasket();
  },
  methods: {
    myInfoEvent(data) {
      this.myInfo = data;
    },
    publicEvent(data) {
      this.public = data;
    },
    //学科
    getSubject() {
      this.$get("/api/material/get_subject_data", {}).then((res) => {
        this.subject = res.data;
        this.subject_cur = this.subject[0].subjectId;
        this.getMaterial();
      });
    },
    subjectCheck(e) {
      this.subject_cur = e;
      this.getMaterial();
    },
    //教材
    getMaterial() {
      this.$get("/api/teacher/get_pack_subject_chapter_edition_data", {
        token: localStorage.getItem("token"),
        subject_id: this.subject_cur,
      }).then((res) => {
        this.material = res.data;
        this.material_cur = this.material[0].Id;
        this.getChapter();
      });
    },
    materialSelect(e) {
      this.currentPage = 1;
      this.getChapter();
    },
    //章节
    getChapter() {
      // this.$get("/api/teacher/get_pack_chapter_data",{
      this.$get("/api/teacher/get_new_pack_chapter_data", {
        token: localStorage.getItem("token"),
        subject_id: this.subject_cur,
        edition_id: this.material_cur,
      }).then((res) => {
        this.old_chapter = "";
        this.chapter = [];
        this.chapter_cur = "";
        this.list = [];
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            res.data[i].open = false;
            if (res.data[i].subordinate.length > 0) {
              for (let j = 0; j < res.data[i].subordinate.length; j++) {
                res.data[i].subordinate[j].open = false;
                /////////////
                if (res.data[i].subordinate[j].subordinate.length > 0) {
                  for (
                    let l = 0;
                    l < res.data[i].subordinate[j].subordinate.length;
                    l++
                  ) {
                    res.data[i].subordinate[j].subordinate[l].open = false;
                  }
                }

                /////////
              }
            }
          }
          this.chapter = res.data;
          this.old_chapter = res.data;

          if (this.chapter_cur != "") {
            this.getTeacher();
          }
        }
      });
    },
    firstOpen(e) {
      console.log(e);
      if (this.chapter[e].open) {
        this.chapter[e].open = false;
      } else {
        this.chapter = JSON.parse(JSON.stringify(this.old_chapter));
        this.chapter = this.chapter.map((item, index) => {
          item.open = index == e ? true : false;
          return item;
        });
        this.firstOpenId = this.chapter[e].gradeId;
        this.type = 1;
        this.currentPage = 1;
        this.getTeacher();
        //  this.getVideo();
      }
    },
    secondOpen(index, secondIndex) {
      if (this.chapter[index].subordinate[secondIndex].open) {
        this.chapter[index].subordinate[secondIndex].open = false;
      } else {
        this.chapter = JSON.parse(JSON.stringify(this.old_chapter));

        this.chapter[index].open = true;
        this.firstOpenId = this.chapter[index].gradeId;
        this.pack_type_id = this.chapter[index].subordinate[secondIndex].id;
        this.chapter[index].subordinate[secondIndex].open = true;
        this.type = 2;
        this.currentPage = 1;
        this.getTeacher();
        //   this.getVideo();
      }
    },
    threeOpen(index, secondIndex, threeIndex) {
      if (
        this.chapter[index].subordinate[secondIndex].subordinate[threeIndex]
          .open
      ) {
        this.chapter[index].subordinate[secondIndex].subordinate[
          threeIndex
        ].open = false;
      } else {
        this.chapter = JSON.parse(JSON.stringify(this.old_chapter));

        this.chapter[index].open = true;
        this.chapter[index].subordinate[secondIndex].open = true;
        this.firstOpenId = this.chapter[index].gradeId;
        this.pack_type_id = this.chapter[index].subordinate[secondIndex].id;
        this.chapter_str =
          this.chapter[index].subordinate[secondIndex].subordinate[
            threeIndex
          ].chapter;
        this.chapter[index].subordinate[secondIndex].subordinate[
          threeIndex
        ].open = true;

        this.type = 3;
        this.currentPage = 1;
        this.getTeacher();
      }
    },
    knowledgeCheck(id, pack_type_id, chapter, gradeId) {
      this.type = 4;
      this.chapter_cur = id;
      this.firstOpenId = gradeId;
      this.chapter_str = chapter;
      this.currentPage = 1;
      this.pack_type_id = pack_type_id;
      this.getTeacher();
    },
    //教师
    getTeacher() {
      this.$get("/api/teacher/get_new_teacher_data", {
         token: localStorage.getItem("token"),
        // chapter_id: this.chapter_cur,
        edition_id: this.material_cur,
        type: this.type ? this.type : 4,
        subject_id: this.subject_cur,
        grade_id: this.firstOpenId,
        pack_type_id: this.pack_type_id,
        chapter: this.chapter_str,
        unit: this.chapter_cur,
      }).then((res) => {
        if (res.data.length > 0) {
          res.data.unshift({ teacher_id: "", name: "全部" });
        }
        this.teacher = res.data;

        this.currentPage = 1;
        this.getList();
      });
    },
    directionCheck(e) {
      this.direction_cur = e;
      this.currentPage = 1;
      this.getList();
    },       
    teacherCheck(e) {
      this.teacher_cur = e;
      this.currentPage = 1;
      this.getList();
    },
    orderCheck(e) {
      this.order_cur = e;
      this.currentPage = 1; 
      this.getList();
    },
    //视频
    getList() {
      this.$get("/api/teacher/get_video_work_new_list", {
        token: localStorage.getItem("token"),
         subject_id: this. subject_cur,
        //grade_id: this.grade_cur.gradeId,
        page: this.currentPage,
        limit: this.pageSize,
        edition_id: this.material_cur,
        token: localStorage.getItem("token"),
        unit: this.chapter_cur,
        teacher_id: this.teacher_cur,
        direction: this.direction_cur,
        order: this.order_cur,
        type: this.type,
        grade_id: this.firstOpenId,
        chapter: this.chapter_str,
        pack_type_id: this.pack_type_id,
      }).then((res) => {
        if (res.data.data.length > 0) {
          for (let i = 0; i < res.data.data.length; i++) {
            res.data.data[i].check_num = 0;
            for (let j = 0; j < res.data.data[i].video.length; j++) {
              if (res.data.data[i].video[j].is_exist == 1) {
                res.data.data[i].check_num++;
              }
            }
            if (res.data.data[i].check_num == res.data.data[i].video.length) {
              res.data.data[i].is_exist = 1;
            }
          }
        }
        this.list = res.data.data;
        this.total = res.data.total;
      });
    },
    listOpen(index) {
      if (this.list[index].open) {
        this.list[index].open = false;
      } else {
        this.list[index].open = true;
      }
    },
    //作业篮
    getBasket() {
      this.$get("/api/teacher/get_basket_statistics_message", {
        token: localStorage.getItem("token"),
      }).then((res) => {
        this.basket = res.data;
      });
    },
    //加入
    joinAll(index) {
      var pack_id = this.list[index].id;
      var item_ids = [];
      for (let i = 0; i < this.list[index].video.length; i++) {
        if (this.list[index].video[i].is_exist == 0) {
          item_ids.push(this.list[index].video[i].id);
        }
      }
      item_ids = item_ids.join(",");
      this.$get("/api/teacher/post_join_basket", {
        token: localStorage.getItem("token"),
        item_type: "video", //video视频,test组卷,papers试卷,exam校本试卷
        item_ids: item_ids,
        pack_id: pack_id,
      }).then((res) => {
        this.list[index].is_exist = 1;
        for (let i = 0; i < this.list[index].video.length; i++) {
          this.list[index].video[i].is_exist = 1;
        }
        this.$message({
          type: "success",
          message: res.msg,
          duration: 1500,
        });
        this.getBasket();
      });
    },
    join(index, secondIndex) {
      var len = 0;
      var pack_id = this.list[index].id;
      var item_ids = this.list[index].video[secondIndex].id;
      this.$get("/api/teacher/post_join_basket", {
        token: localStorage.getItem("token"),
        item_type: "video", //video视频,test组卷,papers试卷,exam校本试卷
        item_ids: item_ids,
        pack_id: pack_id,
      }).then((res) => {
        this.list[index].video[secondIndex].is_exist = 1;
        for (let i = 0; i < this.list[index].video.length; i++) {
          if (this.list[index].video[i].is_exist == 1) {
            len++;
          }
        }
        if (len == this.list[index].length) {
          this.list[index].is_exist = 1;
        }
        this.$message({
          type: "success",
          message: res.msg,
          duration: 1500,
        });
        this.getBasket();
      });
    },
    //移除
    removeAll(index) {
      var pack_id = this.list[index].id;
      var item_ids = [];
      for (let i = 0; i < this.list[index].video.length; i++) {
        item_ids.push(this.list[index].video[i].id);
      }
      item_ids = item_ids.join(",");
      this.$get("/api/teacher/post_remove_basket", {
        token: localStorage.getItem("token"),
        item_type: "video", //video视频,test组卷,papers试卷,exam校本试卷
        item_ids: item_ids,
        pack_id: pack_id,
      }).then((res) => {
        this.list[index].is_exist = 0;
        for (let i = 0; i < this.list[index].video.length; i++) {
          this.list[index].video[i].is_exist = 0;
        }
        this.$message({
          type: "success",
          message: res.msg,
          duration: 1500,
        });
        this.getBasket();
      });
    },
    remove(index, secondIndex) {
      var len = 0;
      var pack_id = this.list[index].id;
      var item_ids = this.list[index].video[secondIndex].id;
      this.$get("/api/teacher/post_remove_basket", {
        token: localStorage.getItem("token"),
        item_type: "video", //video视频,test组卷,papers试卷,exam校本试卷
        item_ids: item_ids,
        pack_id: pack_id,
      }).then((res) => {
        this.list[index].video[secondIndex].is_exist = 0;
        for (let i = 0; i < this.list[index].video.length; i++) {
          if (this.list[index].video[i].is_exist == 1) {
            len++;
          }
        }
        if (len != this.list[index].length) {
          this.list[index].is_exist = 0;
        }
        this.$message({
          type: "success",
          message: res.msg,
          duration: 1500,
        });
        this.getBasket();
      });
    },
    handleCurrentChange: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
  },
};
</script>

<style>
</style>
